import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from '@partials/contents-modal';
// -------------------------------------------------------

class ProjectPostContents extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    let data = this.props.data;
    
    let event = data.event; 
    event.showPostContents = this.showPostContents.bind(this);
    data.event.updateData.bind(this)('event', event);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal         : false,
      detail        : {},
      contents      : [],
      main_type     : 'custom',
      project_id    : null,
      insta_user_id : null,
    };
  }
  // -------------------------------------------------------
  
  /*
   * 投稿コンテンツ一覧の取得
   */
  showPostContents(project_id, insta_user_id) {
    Utils.request.bind(this)('/api/project/workflow/get_post_contents', { project_id: project_id, insta_user_id: insta_user_id },
      function(res){
        
        let main_contents = [];
        let main_type = 'custom';
        
        let data = res.body.data;
        data.post_contents.map((d) => { if( d.media_type != '' ) main_contents.push(d.media_type); });
        
        if( main_contents.length == 0 ){
          data.project_post_contents.map((d) => { if( d.media_type != '' ) main_contents.push(d.media_type); });
        }
        
        // モーダル表示
        this.toogleModal.bind(this)(true);
        
        this.setState({ main_type: main_type, contents: main_contents, project_id: project_id, insta_user_id: insta_user_id });
        
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  /*
   * 投稿コンテンツの更新
   */
  setPostContents() {
    Utils.request.bind(this)('/api/project/workflow/set_post_contents', { project_id: this.state.project_id, insta_user_id: this.state.insta_user_id, contents: this.state.contents },
      function(res){
        
        if( this.props.refresh_ev != undefined ) this.props.refresh_ev.bind(this)();
        this.toogleModal.bind(this)(false);
        
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  /*
   * モーダルの操作
   */
  toogleModal(flg) {
    this.setState({ modal: flg });
    
    if( flg == true  ) Utils.fixedContents();
    if( flg == false ){
      Utils.unlockFixedContents();
      if( this.props.data.event.refreshProject != undefined ) this.props.data.event.refreshProject.bind(this)();
      if( this.props.refresh_ev != undefined ) this.props.refresh_ev.bind(this)();
    }
  }
  // -------------------------------------------------------
  
  /*
   * タブの切替
   */
  changeTab(main_type, contents) {
    this.setState({ main_type: main_type, contents: contents });
  }
  // -------------------------------------------------------
  
  /*
   * コンテンツ追加
   */
  plus(main_type) {
    let contents = this.state.contents;
    contents.push(main_type);
    this.setState({ contents: contents.sort(), main_type: 'custom' });
  }
  // -------------------------------------------------------
  
  /*
   * コンテンツ削除
   */
  remove(no) {
    let contents = this.state.contents;
    contents = contents.filter((d, key) => { if( key != no ) return d; });
    this.setState({ contents: contents.sort(), main_type: 'custom' });
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.state.detail;
    
    let contents_temp = [];
    
    return (
      <div className="project-post-contents">
        <ContentsModal
          view     = {this.state.modal}
          width    = {600}
          height   = {330}
          close_ev = {this.toogleModal.bind(this, false)}
          html     = {
            <div className="modal-item">
              <div className="modal-main-contents">
                
                <h3>投稿するメディア</h3>
                
                <div className="preview">
                  { this.state.contents.map((id, key) => {
                    let name = Const.value.contents_type[id];
                    
                    let item_no = 1;
                    contents_temp.map((tid) => { if( tid == id ) item_no++; });
                    contents_temp.push(id);
                    
                    if( item_no > 1 ) name += (' '+ item_no);
                    
                    return (
                      <div key={key}>
                        {name}<i className="material-icons" onClick={this.remove.bind(this, key)}>close</i>
                      </div>
                    );
                  })}
                  {(this.state.contents.length == 0) && <p className="none">投稿種別を選択してください</p>}
                </div>
                
                <div className="manual-buttons">
                  { Const.value.contents_type_list.map((d, key) => {
                    return <div key={key} onClick={this.plus.bind(this, d.id)}><i className="material-icons">add</i>{d.name}を追加</div>;
                  })}
                </div>
                
                { (this.state.contents.length > 0)
                  ? <div className="button done" onClick={this.setPostContents.bind(this)}>保存</div>
                  : <div className="button off" >保存</div>
                }
                
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProjectPostContents;